import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

// The message a list or page shows instead of its content: a failed load (with retry) or nothing to show.
@Component({
  selector: 'app-status-card',
  templateUrl: './status-card.component.html',
  styleUrls: ['./status-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StatusCardComponent {
  @Input() state: 'loading' | 'ready' | 'error' = 'ready'
  @Input() empty = false
  @Input() errorTitle = 'Az eseményeket most nem sikerült betölteni.'
  @Input() emptyTitle = 'Nincs megjeleníthető esemény.'
  @Input() emptyText = ''
  @Input() backLink = false
  @Output() retry = new EventEmitter<void>()
}
